import { API_URL } from "../config/consts";

export const authUrl = {
  login_password: `${API_URL}/auth/login`,
  refresh_token: `${API_URL}/auth/refresh`,
  logout: `${API_URL}/auth/logout`,
  login_send_otp: `${API_URL}/auth/sendOtp`,
  login_verify_otp: `${API_URL}/auth/verifyOtp`,
  // Username + email-OTP login (additive; gated by GET /auth/config).
  auth_config: `${API_URL}/auth/config`,
  login_otp_start: `${API_URL}/auth/login/otp/start`,
  login_otp_verify: `${API_URL}/auth/login/otp/verify`,
  change_password: `${API_URL}/auth/change-password`,
  forgot_password: `${API_URL}/auth/forgot-password`,
  reset_password: `${API_URL}/auth/reset-password`,
  forgot_password_start: `${API_URL}/auth/forgot-password/start`,
  forgot_password_verify: `${API_URL}/auth/forgot-password/verify`,
  forgot_password_complete: `${API_URL}/auth/forgot-password/complete`,
  forgot_password_resend: `${API_URL}/auth/forgot-password/resend`,
  accept_invite: `${API_URL}/auth/accept-invite`,
  active_store: `${API_URL}/auth/active-store`,
  // Device-Bound Access (mTLS) self-serve provisioning — download the shared
  // .p12 (gated by deviceProvisioningEnabled on GET /auth/config).
  device_cert: `${API_URL}/auth/device-cert`,

  user_profile: `${API_URL}/auth/me`,
  edit_profile: `${API_URL}/auth/me`,
  update_password: `${API_URL}/auth/change-password`,
  email_change_start: `${API_URL}/auth/me/email-change/start`,
  email_change_verify: `${API_URL}/auth/me/email-change/verify`,

  get_user_list: `${API_URL}/users/list`,
  user: `${API_URL}/users`,
  user_activate: `${API_URL}/users/activate`,
  user_deactivate: `${API_URL}/users/deactivate`,

  get_user_role: `${API_URL}/roles/list`,
  post_user_roles: `${API_URL}/roles`,
  role_list_user: `${API_URL}/roles/user-actions`,
  user_modules_actions: `${API_URL}/users/modules/actions`,
  roles: `${API_URL}/roles`,
  role_permissions: `${API_URL}/roles/permissions`,
  store_type_permissions: `${API_URL}/store-type-permissions`,

  // Audit log
  audit_logs: `${API_URL}/audit-logs`,
  audit_logs_export: `${API_URL}/audit-logs/export`,

  // Stores (store-management Phase 2)
  store_list: `${API_URL}/stores`,
  store_get_by_id: `${API_URL}/stores/by-id`,
  store_create: `${API_URL}/stores`,
  store_update: `${API_URL}/stores`,
  store_check_unique: `${API_URL}/stores/check-unique`,
  store_activate: `${API_URL}/stores/activate`,
  store_deactivate: `${API_URL}/stores/deactivate`,
  store_address_list: `${API_URL}/stores/addresses`,
  store_address_create: `${API_URL}/stores/addresses`,
  store_address_update: `${API_URL}/stores/addresses`,
  store_address_deactivate: `${API_URL}/stores/addresses/deactivate`,

  // Customers (customer-management Phase 1 + 2)
  customer_list: `${API_URL}/customers`,
  customer_get_by_id: `${API_URL}/customers/by-id`,
  customer_by_mobile: `${API_URL}/customers/by-mobile`,
  customer_create: `${API_URL}/customers`,
  customer_update: `${API_URL}/customers`,
  customer_check_unique: `${API_URL}/customers/check-unique`,
  customer_deactivate: `${API_URL}/customers/deactivate`,
  customer_reactivate: `${API_URL}/customers/reactivate`,

  // Registers (POS Billing PRD 1 — per-store billing config + numbering)
  register_list: `${API_URL}/registers`,
  register_get_by_id: `${API_URL}/registers/by-id`,
  register_by_store: `${API_URL}/registers/by-store`,
  register_check_unique: `${API_URL}/registers/check-unique`,
  register_create: `${API_URL}/registers`,
  register_update: `${API_URL}/registers`,
  register_activate: `${API_URL}/registers/activate`,
  register_deactivate: `${API_URL}/registers/deactivate`,

  // Companies (transporter master — Multi-Challan PRD Phase 1)
  company_list: `${API_URL}/companies`,
  company_get_by_id: `${API_URL}/companies/by-id`,
  company_check_unique: `${API_URL}/companies/check-unique`,
  company_create: `${API_URL}/companies`,
  company_update: `${API_URL}/companies`,
  company_deactivate: `${API_URL}/companies/deactivate`,
  company_reactivate: `${API_URL}/companies/reactivate`,

  expense_category_list: `${API_URL}/expense-categories`,
  expense_category_get_by_id: `${API_URL}/expense-categories/by-id`,
  expense_category_create: `${API_URL}/expense-categories`,
  expense_category_update: `${API_URL}/expense-categories`,
  expense_category_deactivate: `${API_URL}/expense-categories/deactivate`,
  expense_category_reactivate: `${API_URL}/expense-categories/reactivate`,
  expense_list: `${API_URL}/expenses`,
  expense_get_by_id: `${API_URL}/expenses/by-id`,
  expense_create: `${API_URL}/expenses`,
  expense_update: `${API_URL}/expenses`,
  expense_delete: `${API_URL}/expenses`,
  expense_approve: `${API_URL}/expenses/approve`,
  expense_reject: `${API_URL}/expenses/reject`,

  // Discounts (promotion master — Discount PRD Phase 1)
  discount_list: `${API_URL}/discounts`,
  discount_get_by_id: `${API_URL}/discounts/by-id`,
  discount_create: `${API_URL}/discounts`,
  discount_update: `${API_URL}/discounts`,
  discount_deactivate: `${API_URL}/discounts/deactivate`,
  discount_reactivate: `${API_URL}/discounts/reactivate`,
  discount_report: `${API_URL}/discounts/report`,

  // Memberships (Discount/Membership/Loyalty PRD Phase 3)
  membership_plan_list: `${API_URL}/membership-plans`,
  membership_plan_get_by_id: `${API_URL}/membership-plans/by-id`,
  membership_plan_create: `${API_URL}/membership-plans`,
  membership_plan_update: `${API_URL}/membership-plans`,
  membership_plan_deactivate: `${API_URL}/membership-plans/deactivate`,
  membership_plan_reactivate: `${API_URL}/membership-plans/reactivate`,
  membership_active: `${API_URL}/memberships/active`,
  membership_redeem: `${API_URL}/memberships/redeem`,
  loyalty_config: `${API_URL}/loyalty/config`,
  loyalty_balance: `${API_URL}/loyalty/balance`,
  loyalty_ledger: `${API_URL}/loyalty/ledger`,

  // Reports (Sales & Inventory Reporting — Reports PRD)
  report_sales: `${API_URL}/reports/sales`,
  report_stock_aging: `${API_URL}/reports/stock-aging`,
  report_article_movement: `${API_URL}/reports/article-movement`,

  // Accounting & Financial Reports (Accounting PRD)
  accounting_trading_pl: `${API_URL}/accounting/trading-pl`,
  accounting_purchase_sale: `${API_URL}/accounting/purchase-sale`,
  accounting_config: `${API_URL}/accounting/config`,

  // Credit Notes (store-credit instrument — Credit Note PRD Phase 1)
  credit_note_list: `${API_URL}/credit-notes`,
  credit_note_get_by_id: `${API_URL}/credit-notes/by-id`,
  credit_note_by_number: `${API_URL}/credit-notes/by-number`,
  credit_note_redeem_otp: `${API_URL}/credit-notes/redeem-otp`,
  credit_note_create: `${API_URL}/credit-notes`,
  credit_note_cancel: `${API_URL}/credit-notes/cancel`,

  // Sales Return (store-credit refund — Return PRD Phase 1)
  returns_returnable_bill: `${API_URL}/returns/returnable-bill`,
  returns_create: `${API_URL}/returns`,
  returns_list: `${API_URL}/returns`,
  returns_by_id: `${API_URL}/returns/by-id`,
  returns_approve: `${API_URL}/returns/approve`,
  returns_reject: `${API_URL}/returns/reject`,

  // Multi-Challan (wholesale HO -> store dispatch — Multi-Challan PRD Phase 2)
  multi_challan_list: `${API_URL}/multi-challan`,
  multi_challan_get_by_id: `${API_URL}/multi-challan/by-id`,
  multi_challan_create: `${API_URL}/multi-challan`,
  multi_challan_update: `${API_URL}/multi-challan`,
  multi_challan_delete: `${API_URL}/multi-challan`,
  multi_challan_dispatch: `${API_URL}/multi-challan/dispatch`,
  multi_challan_generate_ewaybill: `${API_URL}/multi-challan/generate-ewaybill`,

  // Multi-Invoice (wholesale GST tax invoice — Multi-Invoice PRD Phase 3)
  multi_invoice_list: `${API_URL}/multi-invoice`,
  multi_invoice_get_by_id: `${API_URL}/multi-invoice/by-id`,
  multi_invoice_preview: `${API_URL}/multi-invoice/preview`,
  multi_invoice_create: `${API_URL}/multi-invoice`,
  multi_invoice_update: `${API_URL}/multi-invoice`,
  multi_invoice_delete: `${API_URL}/multi-invoice`,
  multi_invoice_generate_irn: `${API_URL}/multi-invoice/generate-irn`,
  multi_invoice_generate_ewaybill: `${API_URL}/multi-invoice/generate-ewaybill`,
  multi_invoice_pdf: `${API_URL}/multi-invoice/pdf`,
  multi_invoice_pt_file: `${API_URL}/multi-invoice/pt-file`,
  multi_invoice_send_pt_mail: `${API_URL}/multi-invoice/send-pt-mail`,

  // In-app notifications (Multi-Challan PRD Phase 8)
  notification_list: `${API_URL}/notifications`,
  notification_unread_count: `${API_URL}/notifications/unread-count`,
  notification_read: `${API_URL}/notifications/read`,
  notification_stream: `${API_URL}/notifications/stream`,

  // POS Billing — sale checkout / history / void (PRD 2)
  sale_expand: `${API_URL}/sales/expand`,
  sale_preview: `${API_URL}/sales/preview`,
  sale_checkout: `${API_URL}/sales/checkout`,
  sale_list: `${API_URL}/sales`,
  sale_by_id: `${API_URL}/sales/by-id`,
  sale_invoice: `${API_URL}/sales/invoice`,
  sale_void: `${API_URL}/sales/void`,
  sale_hold: `${API_URL}/sales/hold`,
  sale_holds: `${API_URL}/sales/holds`,
  sale_resume: `${API_URL}/sales/hold/resume`,

  // POS Billing — Pine Labs CARD/UPI terminal payments (PRD 4, Phase 2)
  sale_payment_initiate: `${API_URL}/sales/payments/initiate`,
  sale_payment_status: `${API_URL}/sales/payments/status`,
  sale_payment_cancel: `${API_URL}/sales/payments/cancel`,

  // POS Billing — approved-orphan recovery (PRD 4, Phase 3)
  sale_payment_recoverable: `${API_URL}/sales/payments/recoverable`,
  sale_payment_resume: `${API_URL}/sales/payments/resume`,

  // Pine Labs Cleanup+Recovery — manager Terminal Issues + resolution (Phase 4)
  sale_payment_terminal_issues: `${API_URL}/sales/payments/terminal-issues`,
  sale_payment_mark_resolved: `${API_URL}/sales/payments/mark-resolved`,

  // Pine Labs terminal config (store-management Phase 6)
  pine_labs_get: `${API_URL}/stores/pine-labs`,
  pine_labs_save: `${API_URL}/stores/pine-labs`,
  pine_labs_test: `${API_URL}/stores/pine-labs/test`,

  // User ↔ store assignments (store-management Phase 4)
  user_stores: `${API_URL}/users/stores`,

  // Master geo lookups (states + cities)
  master_states: `${API_URL}/master/states`,
  master_cities: `${API_URL}/master/cities`,

  // GSTIN master (gst-and-settings Phase 3 — /gst route)
  gstin_list: `${API_URL}/gstins`,
  gstin_get_by_id: `${API_URL}/gstins/by-id`,
  gstin_create: `${API_URL}/gstins`,
  gstin_update: `${API_URL}/gstins`,
  gstin_verify: `${API_URL}/gstins/verify`,
  gstin_deactivate: `${API_URL}/gstins/deactivate`,
  gstin_reactivate: `${API_URL}/gstins/reactivate`,
  gstin_check_unique: `${API_URL}/gstins/check-unique`,

  // Store ↔ GSTIN assignment (gst-and-settings Phase 4 — Store Detail GST tab)
  store_gstin_current: `${API_URL}/stores/gstin/current`,
  store_gstin_history: `${API_URL}/stores/gstin/history`,
  store_gstin_switch: `${API_URL}/stores/gstin/switch`,

  // HSN library (gst-and-settings Phase 2 — Tax Settings tab)
  hsn_list: `${API_URL}/hsn`,
  hsn_get_by_id: `${API_URL}/hsn/by-id`,
  hsn_create: `${API_URL}/hsn`,
  hsn_update: `${API_URL}/hsn`,
  hsn_check_unique: `${API_URL}/hsn/check-unique`,
  hsn_deactivate: `${API_URL}/hsn/deactivate`,
  hsn_reactivate: `${API_URL}/hsn/reactivate`,

  // Store GST slabs (catalogue-gst Phase 6 — per-store GST price bands)
  store_gst_slab_list: `${API_URL}/store-gst-slabs`,
  store_gst_slab_get_by_id: `${API_URL}/store-gst-slabs/by-id`,
  store_gst_slab_create: `${API_URL}/store-gst-slabs`,
  store_gst_slab_update: `${API_URL}/store-gst-slabs`,
  store_gst_slab_deactivate: `${API_URL}/store-gst-slabs/deactivate`,

  // Invoice Settings (gst-and-settings Phase 5 — Invoice Settings tab)
  invoice_settings_get: `${API_URL}/stores/invoice-settings`,
  invoice_settings_update: `${API_URL}/stores/invoice-settings`,
  invoice_settings_logo_upload: `${API_URL}/stores/invoice-settings/logo`,
  invoice_settings_logo_delete: `${API_URL}/stores/invoice-settings/logo`,
  invoice_settings_sequence: `${API_URL}/stores/invoice-settings/sequence`,
  invoice_settings_sequence_reset: `${API_URL}/stores/invoice-settings/sequence/reset`,

  // Inventory — Products / Styles (garment catalogue). Styles + variants are
  // 100% ERP-fed via /products/sync; the only human mutations are variant
  // enrichment (HSN/GST) + activate/deactivate, plus style soft-delete.
  product_list: `${API_URL}/products`,
  product_get_by_id: `${API_URL}/products/by-id`,
  product_get_by_barcode: `${API_URL}/products/by-barcode`,
  product_deactivate: `${API_URL}/products/deactivate`,
  product_reactivate: `${API_URL}/products/reactivate`,
  // Importer Rework Phase 4 — manual catalogue authoring (SA/HO).
  product_create: `${API_URL}/products`,
  product_update: `${API_URL}/products`,
  product_set_definition: `${API_URL}/products/set-definition`,

  // Inventory — Product SKUs / variants (garment catalogue). GST is now
  // store-band driven (catalogue-gst Phase 5/6) — no SKU enrich/activate;
  // priced variants auto-activate on sync. Variants are a read-only mirror
  // (SKU deactivate retired in BUG-007) — list is the only surface.
  product_sku_list: `${API_URL}/product-skus`,
  product_sku_create: `${API_URL}/product-skus`,
  product_sku_update: `${API_URL}/product-skus`,

  // Inventory — Inbound Parents (inventory-catalogue Phase 4)
  inbound_parents_list: `${API_URL}/inbound-parents`,
  inbound_parents_get_by_id: `${API_URL}/inbound-parents/by-id`,
  inbound_parents_stock: `${API_URL}/inbound-parents/stock`,
  inbound_stock_add: `${API_URL}/inbound-parents`,
  inbound_stock_update: `${API_URL}/inbound-parents`,

  // Inventory — Zoho bulk importer (Zoho Inventory Importer PRD, Phase 5).
  // Multipart: 3 files (itemFile/compositeFile/inventoryFile) + ?storeId=.
  import_dry_run: `${API_URL}/import/dry-run`,
  import_commit: `${API_URL}/import/commit`,
  // Importer Rework — global Product import (Item + Composite, no store).
  import_products_dry_run: `${API_URL}/import/products/dry-run`,
  import_products_commit: `${API_URL}/import/products/commit`,
  // Importer Rework — per-store Inventory (stock) import (Inventory Summary only;
  // store from the active X-Store-Id, no ?storeId=).
  import_stock_dry_run: `${API_URL}/import/stock/dry-run`,
  import_stock_commit: `${API_URL}/import/stock/commit`,
  // Own-Template Excel import — download a blank template, dry-run + commit a
  // filled workbook. Products = global (no store); Stock = active X-Store-Id.
  import_products_template: `${API_URL}/import/products/template`,
  import_products_template_dry_run: `${API_URL}/import/products/template/dry-run`,
  import_products_template_commit: `${API_URL}/import/products/template/commit`,
  import_stock_template: `${API_URL}/import/stock/template`,
  import_stock_template_dry_run: `${API_URL}/import/stock/template/dry-run`,
  import_stock_template_commit: `${API_URL}/import/stock/template/commit`,

  // Inventory — Stock movements (Stock Levels/Adjustment/Low Stock Alerts removed V108)
  stock_movements_list: `${API_URL}/stock-movements`,

  // GRN (grn Phase 1 — empty list endpoint)
  grn_list: `${API_URL}/grn`,
  grn_get_by_id: `${API_URL}/grn/by-id`,
  grn_create: `${API_URL}/grn`,
  grn_update: `${API_URL}/grn`,
  grn_submit: `${API_URL}/grn/submit`,
  grn_approve: `${API_URL}/grn/approve`,
  grn_receive: `${API_URL}/grn/receive`,
  grn_reject: `${API_URL}/grn/reject`,
  grn_cancel: `${API_URL}/grn/cancel`,

  // Master types (state / city / store-type lookups)
  master_type_list: `${API_URL}/master-types/list`,

  // Files
  file_upload: `${API_URL}/files/upload`,
  file_presigned_url: `${API_URL}/files/presigned-url`,
};
